const defaultUrl = import.meta.env.VITE_ZOOM_SCHEDULING_URL?.trim() || "";

const link15 = import.meta.env.VITE_ZOOM_LINK_15?.trim() || defaultUrl;
const link30 = import.meta.env.VITE_ZOOM_LINK_30?.trim() || defaultUrl;
const link60 = import.meta.env.VITE_ZOOM_LINK_60?.trim() || defaultUrl;

export const CONTACT_PHONE = "+91 8178462090";
export const CONTACT_PHONE_TEL = "tel:+918178462090";

export const hasZoomScheduling =
  Boolean(link15) || Boolean(link30) || Boolean(link60);

export const meetingOptions = [
  {
    id: "15",
    minutes: 15,
    title: "Quick Intro",
    description: "Brief overview of your project and goals",
    url: link15,
    badge: "Fastest",
  },
  {
    id: "30",
    minutes: 30,
    title: "Free Consultation",
    description: "Discovery call — no commitment, no sales pressure",
    url: link30,
    badge: "Most popular",
  },
  {
    id: "60",
    minutes: 60,
    title: "Deep Dive",
    description: "Detailed scoping, timeline, and technical discussion",
    url: link60,
    badge: null,
  },
].filter((option) => Boolean(option.url));

export const timezoneNote = "All times shown in IST (UTC+5:30)";
